import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { periodSelector } from '../../../../store/selectors';
import { setFilterState } from '../../../../store/actions';
import { filterNames } from '../../../../constants/common';
import DateRangePicker from '../../../../../../components/DateRangePicker/DateRangePicker';


const SelectPeriod = () => {
  const dispatch = useDispatch();
  const period = useSelector(periodSelector);

  const handleChange = (dates) => {
    dispatch(setFilterState({ filterName: filterNames.period, value: dates }));
  };

  const handle = (dates) => {
    return dispatch(setFilterState({ filterName: filterNames.period, value: dates }));
  };

  const defineActiveRange = (dates) => {
    const [currentFromDate, currentToDate] = period;
    const [fromDate, toDate] = dates.range;

    return currentFromDate.isSame(fromDate, 'day') && currentToDate.isSame(toDate, 'day');
  };

  return (
    <DateRangePicker
    storedDatesRange={period}
    handleSelectedRange={handleChange}
    getDataByRangeAction={handle}
    defineActiveRange={defineActiveRange}
    />
  );
};

export default SelectPeriod;
